import { fetchResyncBlockedTrips, resyncTrip } from '@/backend/tripsResyncApi';

const getDefaultState = () => ({
  blockedTrips: [],
  loading: false,
  error: null,
  page: 1,
  perPage: 50,
  totalItems: 0,
  requestSeq: 0,
});

const state = getDefaultState();
const namespaced = true;

const mutations = {
  SET_LOADING(state, value) { state.loading = value; },
  SET_ERROR(state, value) { state.error = value; },
  SET_PAGE(state, value) { state.page = value; },
  SET_REQUEST_SEQ(state, value) { state.requestSeq = value; },
  SET_BLOCKED_TRIPS(state, response) {
    state.blockedTrips = Array.isArray(response?.items) ? response.items : [];
    state.page = Number.isFinite(response?.current_page) ? response.current_page : 1;
    state.totalItems = Number.isFinite(response?.total_items) ? response.total_items : state.blockedTrips.length;
  },
};

const actions = {
  async getBlockedTrips({ commit, state }, options = {}) {
    const force = Boolean(options.force);
    if (state.loading && !force) return;

    const requestSeq = state.requestSeq + 1;
    commit('SET_REQUEST_SEQ', requestSeq);
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const data = await fetchResyncBlockedTrips({
        page: state.page,
        per_page: state.perPage,
        ...options.filters,
      });
      if (requestSeq === state.requestSeq) {
        commit('SET_BLOCKED_TRIPS', data);
      }
    } catch (error) {
      if (requestSeq === state.requestSeq) {
        commit('SET_ERROR', error);
      }
    } finally {
      if (requestSeq === state.requestSeq) {
        commit('SET_LOADING', false);
      }
    }
  },

  setPage({ commit, dispatch }, value) {
    commit('SET_PAGE', value);
    dispatch('getBlockedTrips');
  },

  async resyncTrip({ commit }, { trip_id, tms_id, dry = false } = {}) {
    commit('SET_ERROR', null);
    try {
      return await resyncTrip({ trip_id, tms_id, dry });
    } catch (error) {
      commit('SET_ERROR', error);
      throw error;
    }
  },
};

const getters = {
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
  getBlockedTrips: (state) => state.blockedTrips,
  getTotalItems: (state) => state.totalItems,
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};